import { atom } from "recoil";
import { CommonInfoDetails } from "src/models/commonInfoDetails.models";

const commonInfoDetailsData = atom<CommonInfoDetails>({
  key: "commonInfoDetails",
  default: {
    important_positions: [],
    job_cancel_reasons: [],
    job_categories: [],
    job_roles: [],
    job_services: [],
    licenses: [],
    modules: [],
    notes_activity: [],
    office_contracts: [],
    payment_methods: [],
    practice: [],
    professional_contracts: [],
    prophy_options: [],
    referrals: [],
    roles: [],
    skills: [],
    softwares: [],
    speciality_skills: [],
    unassign_reason: [],
  },
});

export { commonInfoDetailsData };
